// extracted by mini-css-extract-plugin
export default {"header":"Institution_header__qP7lu","content":"Institution_content__ErccL","divider":"Institution_divider__xbote"};